import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-payment-successful-popup',
  templateUrl: './payment-successful-popup.component.html',
  styleUrls: ['./payment-successful-popup.component.scss'],
})
export class PaymentSuccessfulPopupComponent implements OnInit {

  @Input() title: any;
  @Input() image: any;
  @Input() text: any;
  @Input() email: any;
  @Input() description: any;
  @Input() buttons: any;
  @Input() small: any;
  public environment = environment;
  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {}

  close(){
    this.modalCtrl.dismiss();
  }
}
